export const style = {
  label: {
    fontSize: `11px`,
    fontWeight: 400,
    padding: `0.4em 0.8em 0.5em`,
    display: `inline-block`,
    color: `white`,
    '::first-letter': {
      textTransform: `uppercase`
    }
  },
  pending: {
    background: `#dddddd`
  },
  canceled: {
    background: `#d9534f`
  },
  completed: {
    background: `#5cb85c`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/transactions/status.js